export default __webpack_public_path__ + "static/media/bumibiruputih.e463d4c8.png";